import React, { Component } from 'react';

import FormField from '../form-field/FormField';
import PasswordField from '../form-field/PasswordField';
import './style.css';


export default class Contacts extends Component {
  render() {
    const classes = this.props.styleClasses ? this.props.styleClasses.join(' ') : '';
    return (
      <div>
        <div className={classes + ' form__info-block'}>
          <div className='form__tips'>
            Контактная информация нужна для экстренной связи. Мы не даём эту информацию третьим лицам.
          </div>
          <div className='form__inputs'>
            <FormField
              title='Email' type='text' fieldName='email' clearFields={this.props.clearFields}
              errorHandler={this.props.emailHandler} ref='email' defaultValue={this.props.defaultEmailValue}
            />
            <div className='form__tips form__tips_pass-mobile'>
              Не менее 8 символов
            </div>
            <PasswordField
              title={this.props.newPass ? 'Новый пароль' : 'Пароль'} fieldName='password' clearFields={this.props.clearFields}
              errorHandler={this.props.passwordHandler} ref='password'
            />
            <FormField
              title='Телефон' type='text'
              fieldName='phoneNumber'  clearFields={this.props.clearFields}
              errorHandler={this.props.phoneHandler} defaultValue={this.props.defaultPhoneValue}
            />
          </div>
          <div className='form__tips form__tips_pass-desktop'>
            Не менее 8 символов
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/blocks/form-blocks/Contacts.js